import React from "react";

const ApiNotFound = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
        textAlign: "center",
      }}
    >
      <img
        src="/Api.svg"
        alt="API Not Found"
        style={{ width: "300px", marginBottom: "20px" }}
      />

      <h1 style={{ fontSize: "40px", marginBottom: "10px" }}>
        API Route Not Found
      </h1>

      <p style={{ fontSize: "18px", color: "#666", maxWidth: "450px" }}>
        The API endpoint you are trying to access does not exist.
        Please check the URL or contact the administrator.
      </p>
      <a
        href="/"
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          background: "#007bff",
          color: "#fff",
          borderRadius: "5px",
          textDecoration: "none",
        }}
      >
        Go to Home
      </a>
    </div>
  );
};

export default ApiNotFound;
